<ion-header>
  <app-detailheader [include]="getInclude()" type="book" [title]="book?.book_title" *ngIf="book"
    [id]="book?.book_id" [favorited]="book?.favorite" (notify)="headerNotify($event)">
  </app-detailheader>
</ion-header>
<ion-content padding style="background-color: #f4f4f4" *ngIf="book">
  <div class="books-header">
    <span class="subheader-row1">Actu Livres</span>
    <span [ngClass]="{'mquo': themeClass === 'mquo', 'lepq': themeClass === 'lepq', 'actu': themeClass === 'actu'}" class="subheader-row2">PARTENARIAT</span>
  </div>
  <ion-card>
    <ion-grid>
      <ion-row>
        <ion-col size="6">
          <div>
            <div id="card-logo">
              <img *ngIf="book.book_edition_image" src="{{book.book_edition_image.url}}"/>
            </div>
          </div>
        </ion-col>
        <ion-col size="6" style="text-align: right"> <div id="card-pubdate"></div> </ion-col>
      </ion-row>
    </ion-grid>
    <!-- <ion-grid *ngIf="book.book_header_color" [ngStyle] = "{'background-color': book.book_header_color}">
        <ion-row>
          <ion-col col-3>
            <img src="{{book.book_logo.url}}" width="50%">
          </ion-col>
          <ion-col col-9>
            <div class="tagline">{{book.book_tagline}}</div>
          </ion-col>
        </ion-row>
      </ion-grid> -->
    <div class="rule-logo-container"> <div class="rule-logo"></div> </div>
    <ion-card-content>
      <div [ngClass]="{'article-detail-category-title-container': true, 'mquo': book.book_newspaper === 'mquo', 'lepq': book.book_newspaper === 'lepq', 'actu': book.book_newspaper === 'actu', 'aeco': book.book_newspaper === 'aeco', 'mlwk': book.book_newspaper === 'mlwk', 'mlne': book.book_newspaper === 'mlne', 'week': book.book_newspaper === 'week', 'mwne': book.book_newspaper === 'mwne', 'woch': book.book_newspaper === 'woch', 'sema': book.book_newspaper === 'sema'}">
        <div class="clear"></div>
        <h2>{{book.book_title}}</h2>
      </div>
      <span class="author" *ngIf="book.book_author" [innerHTML]="book.book_author"  ></span>
      <div class="article-list-image"
        [ngClass]="{'lepq': book.book_newspaper === 'lepq', 'mquo': book.book_newspaper === 'mquo', 'actu': book.book_newspaper === 'actu'}"
        *ngIf="book.book_cover">
        <img class="book-cover" src="{{book.book_cover.url}}" />
        <span class="copyright"  *ngIf="book.book_eliseuse_url" (click)="goToExtract(book.book_eliseuse_url, book.book_title)">Lire un extrait </span>
      </div>
      <div class="book-description" *ngIf="book.book_description" [innerHTML]="book.book_description | safeHtml" ></div>
      <div class="book-various-content" *ngIf="book.book_various_content" [innerHTML]="book.book_various_content | safeHtml"></div>
    </ion-card-content>
  </ion-card>
  <!--
    <button  ion-item detail-none (click)="goToBookList(book.book_newspaper)"
      [ngClass]="{'allbooks': true, 'lepq': book.book_newspaper === 'lepq', 'mquo': book.book_newspaper === 'mquo'}">
      VOIR TOUS LES LIVRES
      <ion-icon name="arrow-right-full"></ion-icon>
    </button>
  -->
  <ion-button expand="block" size="large" (click)="goToBookList(book.book_newspaper)"
    [ngClass]="{'allbooks': true, 'lepq': book.book_newspaper === 'lepq', 'mquo': book.book_newspaper === 'mquo'}">
    <ion-label>
      VOIR TOUS LES LIVRES
      <ion-icon slot="end" class="arrow-right-full"></ion-icon>
    </ion-label>
  </ion-button>
  <app-cookie-info></app-cookie-info>
</ion-content>
<ion-footer><app-bottom-menu [isActive]="isActivePage"></app-bottom-menu></ion-footer>
<app-pop-up [show]="tempPopUp" [data]="popup" (popUpNotify)="onNotifyPopUp($event)" #temppopup></app-pop-up>
